export { default as request } from './request'
export { default as getSvgData } from './getSvgData'
